export default "__VITE_ASSET__D1iC2Ieb__"